import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';
import { RetentionOverviewService } from '../services/retention-overview.service';

export const retentionOverviewResolver: ResolveFn<boolean> = async (route, state) => {
  const service = inject(RetentionOverviewService);

  try {
    await service.list();
    return true;
  } catch (error) {
    console.warn('Error loading retention overview:', error);
    return false;
  }
};
